import type { ColorIndicator } from "@/core/dashboard/entities/ColorIndicator";

/**
 * Normalizes a raw backend colorIndicator string to the domain enum.
 * Uses explicit branching to avoid dynamic object access patterns flagged by
 * detect-object-injection.
 */
export function toColorIndicator(
  raw: string | null | undefined,
): ColorIndicator | null {
  switch ((raw ?? "").toUpperCase()) {
    case "GREEN":
      return "GREEN";
    case "ORANGE":
      return "ORANGE";
    case "RED":
      return "RED";
    default:
      return null;
  }
}
